exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#promote-jobsoffer .div-header{\n  background-color: #fcfcfc;\n  margin: 0 !important;\n  padding-bottom: 15px;\n  padding-top: 12px;\n}\n\n#promote-jobsoffer{\n  width: 400px;\n}\n\n#promote-jobsoffer md-dialog-container{\n  border: 1px solid #dadada !important;\n  /*padding: 10px !important;*/\n  overflow: hidden !important;\n  border-radius: 4px !important;\n  margin-top:40px !important;\n  padding: 0px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/promote-jobs-offer-dialog/promote-jobs-offer-dialog.component.css
// module id = ../../../../../src/app/pages/promote-jobs-offer-dialog/promote-jobs-offer-dialog.component.css
// module chunks = main